export const state = {
    savedAsssetTableSorting: [],
  };
  
  export const mutations = {
    ADD_SORT(state, sortSettingsObject) {
        
        // remove old settings if there are for this property
        var earlierSavedSetting = state.savedAsssetTableSorting.filter( obj => 
              obj.propertyId == sortSettingsObject.propertyId)[0];

            if(earlierSavedSetting != undefined)
            {
                var index = state.savedAsssetTableSorting.indexOf(earlierSavedSetting);
                state.savedAsssetTableSorting.splice(index, 1)
            }
        state.savedAsssetTableSorting.push(sortSettingsObject);
    },
  };
  export const actions = {
    addSortSettings({ commit }, sortSettings) {
      commit("ADD_SORT", sortSettings);
    },
  };
  